import { Box } from "@chakra-ui/layout"
import React from "react"

export default function MojoListIcon({ color = `#FF00B4`, size = 12 }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 12 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>BTN_CHECK Default</title>
      <g
        id="Desktop"
        stroke="none"
        stroke-width="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="2_PURCHASE---Plan-Copy"
          transform="translate(-750.000000, -248.000000)"
          fill={color}
          fillRule="nonzero"
        >
          <g id="Group-4" transform="translate(735.000000, 241.000000)">
            <g
              id="BTN_CHECK-Default"
              transform="translate(11.000000, 2.000000)"
            >
              <path
                d="M8.8293457,15.1749674 C9.17114258,15.1749674 9.43888346,15.0382487 9.62687174,14.7591146 L14.958903,6.53320312 C15.0956217,6.328125 15.1525879,6.14013672 15.1525879,5.96354167 C15.1525879,5.49641927 14.810791,5.16031901 14.3322754,5.16031901 C14.0018717,5.16031901 13.8024902,5.2742513 13.6031087,5.59326172 L8.80655924,13.1811523 L6.35701497,10.0935872 C6.16333008,9.86002604 5.96394857,9.75179036 5.67911784,9.75179036 C5.1949056,9.75179036 4.84741211,10.0935872 4.84741211,10.5664062 C4.84741211,10.7714844 4.91577148,10.9651693 5.09236654,11.1702474 L8.03751628,14.7875977 C8.25968424,15.0553385 8.50463867,15.1749674 8.8293457,15.1749674 Z"
                id="􀆅"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
